import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem } from 'polished'

const ERROR_SIZE_MARGIN = 34

export const odSearchForm = (theme: Theme): SerializedStyles =>
  css({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'center',
    position: 'relative',
  })

export const odSearch = css({
  width: '100%',
})

export const datepicker = (isErrorOnRowDirection: boolean): SerializedStyles =>
  css({
    flexShrink: 0,
    ...(isErrorOnRowDirection && {
      marginBottom: rem(ERROR_SIZE_MARGIN),
    }),
  })
